import React from "react";
import { Bar, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement } from 'chart.js';

// 註冊 Chart.js 組件
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement);

function PermissionStatistic() {
  // 模擬數據
  const highestPermissionUsers = 5;  // 擁有最高權限的用戶
  const totalUsers = 20;  // 總用戶數

  // 每人可使用的權限數量
  const userPermissions = [
    { name: 'User A', permissions: 12 },
    { name: 'User B', permissions: 8 },
    { name: 'User C', permissions: 6 },
    { name: 'User D', permissions: 15 },
    { name: 'User E', permissions: 9 }
  ];

  // 條形圖的數據
  const barChartData = {
    labels: userPermissions.map(user => user.name),
    datasets: [{
      label: '每人可使用的權限數量',
      data: userPermissions.map(user => user.permissions),
      backgroundColor: [
        'rgba(255, 99, 132, 0.6)',
        'rgba(54, 162, 235, 0.6)',
        'rgba(255, 206, 86, 0.6)',
        'rgba(75, 192, 192, 0.6)',
        'rgba(153, 102, 255, 0.6)'
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)'
      ],
      borderWidth: 1
    }]
  };

  // 圓餅圖的數據
  const pieChartData = {
    labels: ['擁有最高權限人數', '其他用戶'],
    datasets: [{
      label: '權限人數比例',
      data: [highestPermissionUsers, totalUsers - highestPermissionUsers],
      backgroundColor: [
        'rgba(255, 99, 132, 0.6)',
        'rgba(255, 205, 86, 0.6)'
      ],
      borderColor: [
        'rgba(255, 99, 132, 1)',
        'rgba(255, 205, 86, 1)'
      ],
      borderWidth: 1
    }]
  };

  return (
    <div style={{ padding: '20px', maxWidth: '1200px', margin: 'auto' }}>
      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>權限統計</h1>

      {/* 統計卡片容器，RWD 設計 */}
      <div style={{ 
        display: 'flex', 
        flexWrap: 'wrap', 
        justifyContent: 'space-between', 
        gap: '20px' 
      }}>
        
        {/* 最高權限人數 */}
        <div style={{ 
          flex: '1 1 45%', 
          padding: '20px', 
          border: '1px solid #ddd', 
          borderRadius: '15px', 
          backgroundColor: '#fff', 
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', 
          textAlign: 'center',
          maxWidth: '500px',  // 限制最大寬度
          minWidth: '300px',  // 最小寬度
          height: '400px'  // 高度控制
        }}>
          <h2 style={{ color: '#ff6384' }}>最高權限人數統計</h2>
          <p>{highestPermissionUsers} 人擁有最高權限</p>
          <div style={{ width: '100%', height: '80%' }}>
            <Pie 
              data={pieChartData} 
              options={{ 
                maintainAspectRatio: false, // 取消保持固定比例
                responsive: true, // 響應式
                plugins: {
                  legend: {
                    position: 'bottom'
                  }
                }
              }} 
            />
          </div>
        </div>
        
        {/* 每人可使用的權限數量 */}
        <div style={{ 
          flex: '1 1 45%', 
          padding: '20px', 
          border: '1px solid #ddd', 
          borderRadius: '15px', 
          backgroundColor: '#fff', 
          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', 
          textAlign: 'center',
          maxWidth: '500px',  // 限制最大寬度
          minWidth: '300px',  // 最小寬度
          height: '400px'  // 高度控制
        }}>
          <h2 style={{ color: '#36a2eb' }}>每人可使用的權限數量</h2>
          <div style={{ width: '100%', height: '80%' }}>
            <Bar 
              data={barChartData} 
              options={{ 
                maintainAspectRatio: false, 
                responsive: true, 
                plugins: {
                  legend: {
                    position: 'bottom'
                  }
                }
              }} 
            />
          </div>
        </div>
        
      </div>
    </div>
  );
}

export default PermissionStatistic;
